// extracted by mini-css-extract-plugin
export default {"root":"PageHeader_root__hXjDI"};